import { createAction, props } from '@ngrx/store';
import { FilterSucheItem } from '../../filterSucheModel';
import { DialogData } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';

export const getFilterSeekStart = createAction('ZEIT::GET_FILTER_SEEK_START',
  props<{ string: string, itemFundS: FilterSucheItem }>());
export const getFilterSeekSucceeded = createAction('ZEIT::GET_FILTER_SEEK_SUCCEEDED',
  // tslint:disable-next-line:max-line-length
  props<{ item: DialogData[] }>()); /* Wenn es erfolgreich ist, will ich nicht die Filterwerte also datum und Suche sondern das Resultat also die Einträge in der DB */
export const getFilterSeekFailed = createAction('ZEIT::GET_FILTER_SEEK_FAILED', props<{ error: Error }>());
